/* tslint:disable */
/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root 
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { EmailApi } from './services/custom/Email';
import { PayeeApi } from './services/custom/Payee';
import { PayeeAccountDetailApi } from './services/custom/PayeeAccountDetail';
import { PayeeDetailApi } from './services/custom/PayeeDetail';
import { PayeeShareholderApi } from './services/custom/PayeeShareholder';
import { StorageApi } from './services/custom/Storage';
import { BusinessTypeApi } from './services/custom/BusinessType';
import { PayeeAttachmentApi } from './services/custom/PayeeAttachment';
import { PayeeWebChecklistApi } from './services/custom/PayeeWebChecklist';
import { PayeePaymentProcessingApi } from './services/custom/PayeePaymentProcessing';
import { PayeeBusinessSalesApi } from './services/custom/PayeeBusinessSales';
import { PayeeEStatementAdminApi } from './services/custom/PayeeEStatementAdmin';
import { PayeeECommerceAdminApi } from './services/custom/PayeeECommerceAdmin';
import { PayeeReportingPdpApi } from './services/custom/PayeeReportingPdp';
import { PayeeSalesHistoryApi } from './services/custom/PayeeSalesHistory';
import { PayeeServiceApi } from './services/custom/PayeeService';
import { PayeeServiceDPEApi } from './services/custom/PayeeServiceDPE';
import { PayeeServiceM2UbillerApi } from './services/custom/PayeeServiceM2Ubiller';
import { PayeeSubmissionApi } from './services/custom/PayeeSubmission';
import { ServiceApi } from './services/custom/Service';
import { SubmissionTagApi } from './services/custom/SubmissionTag';
import { SubmissionSubtagMappingApi } from './services/custom/SubmissionSubtagMapping';
import { TagApi } from './services/custom/Tag';
import { SubTagApi } from './services/custom/SubTag';
import { GroupApi } from './services/custom/Group';
import { PayeeAttachmentDetailApi } from './services/custom/PayeeAttachmentDetail';
import { PayeeServiceMIDApi } from './services/custom/PayeeServiceMID';
import { PayeeCardsEcommerceApi } from './services/custom/PayeeCardsEcommerce';
import { PayeePosOutletApi } from './services/custom/PayeePosOutlet';
import { PayeePosApi } from './services/custom/PayeePos';
import { PayeeFraudChecklistApi } from './services/custom/PayeeFraudChecklist';
import { PayeePCIDSSApi } from './services/custom/PayeePCIDSS';
import { RequestAssistanceApi } from './services/custom/RequestAssistance';
import { PayeePosPaymentProcessingApi } from './services/custom/PayeePosPaymentProcessing';
import { PayeePosEstatementAdminApi } from './services/custom/PayeePosEstatementAdmin';
import { CaptchaApi } from './services/custom/Captcha';
import { PayeeJompayApi } from './services/custom/PayeeJompay';
import { PayeeJompayAccountApi } from './services/custom/PayeeJompayAccount';
import { PayeeJompayReportingPdpApi } from './services/custom/PayeeJompayReportingPdp';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        LoopBackAuth,
        LoggerService,
        SDKModels,
        EmailApi,
        PayeeApi,
        PayeeAccountDetailApi,
        PayeeDetailApi,
        PayeeShareholderApi,
        StorageApi,
        BusinessTypeApi,
        PayeeAttachmentApi,
        PayeeWebChecklistApi,
        PayeePaymentProcessingApi,
        PayeeBusinessSalesApi,
        PayeeEStatementAdminApi,
        PayeeECommerceAdminApi,
        PayeeReportingPdpApi,
        PayeeSalesHistoryApi,
        PayeeServiceApi,
        PayeeServiceDPEApi,
        PayeeServiceM2UbillerApi,
        PayeeSubmissionApi,
        ServiceApi,
        SubmissionTagApi,
        SubmissionSubtagMappingApi,
        TagApi,
        SubTagApi,
        GroupApi,
        PayeeAttachmentDetailApi,
        PayeeServiceMIDApi,
        PayeeCardsEcommerceApi,
        PayeePosOutletApi,
        PayeePosApi,
        PayeeFraudChecklistApi,
        PayeePCIDSSApi,
        RequestAssistanceApi,
        PayeePosPaymentProcessingApi,
        PayeePosEstatementAdminApi,
        CaptchaApi,
        PayeeJompayApi,
        PayeeJompayAccountApi,
        PayeeJompayReportingPdpApi,
        internalStorageProvider,
        { provide: SDKStorage, useClass: StorageBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';

